import { AuthorDetails } from 'src/pages/AuthorDetails'
import { combineFallbacks, useAuthorIndex } from 'src/state'
import { NotFoundError } from 'src/services/errors'

export default AuthorDetails

export const getStaticProps = async ({ params }) => {
  const { slug } = params

  const fallback = await combineFallbacks(
    useAuthorIndex.getFallback({ slug })
  ).catch(error => {
    if (error instanceof NotFoundError) return error
    throw error
  })

  return {
    props: { fallback, slug },
    notFound: fallback instanceof NotFoundError,
    revalidate: 10 * 60,
  }
}

export async function getStaticPaths() {
  return { paths: [], fallback: 'blocking' }
}
